import { render } from "./view-blocs.vue?vue&type=template&id=146537d0"
import script from "./view-blocs.js?vue&type=script&lang=js&external"
export * from "./view-blocs.js?vue&type=script&lang=js&external"

import "./view-blocs.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__